export const CORE = 'Core';
export const STRATEGIC = 'Strategic';
export const MODERATE_RISK = 'Moderate Risk';
export const SPECULATIVE = 'Speculative';
export const CORE_SCORE_RISK_FACTORS = ['sectorAssessment', 'sectorOutlook', 'eventAssessment', 'eventOutlook'];

export const CORE_UPPER_LIMIT = 100;
export const CORE_LOWER_LIMIT = 77;
export const STRATEGIC_UPPER_LIMIT = 76;
export const STRATEGIC_LOWER_LIMIT = 32;
export const MODERATE_RISK_UPPER_LIMIT = 31;
export const MODERATE_RISK_LOWER_LIMIT = 11;
export const SPECULATIVE_UPPER_LIMIT = 10;
export const SPECULATIVE_LOWER_LIMIT = 0;
